import { Injectable } from '@angular/core';
import { Permission } from '../model/permission';
import { RestClientService } from 'src/app/core/services/rest/rest-client.service';
import { AssocierPermissionAuProfile } from '../model/associer-permission-au-profile';
import { PermissionSelectedDTO } from '../model/permission-selected-dto';

@Injectable({
    providedIn: 'root'
  })
  export class PermissionService{
  
    constructor(private _restClientService : RestClientService) 
    {}
    

  getPermissions() 
  {
    return this._restClientService.load<Permission[]>('permission/permissions');
  }
  
  add(permission: Permission) {
    return this._restClientService.save<Permission>('permission/add-permission', permission);
  }
  
  getPermissionById(permissionId){
    return this._restClientService.load<Permission>('permission/permission-by-id/'+permissionId);
  }
    
  update(permission: Permission) {
    return  this._restClientService.put<Permission>(`permission/update-permission`, permission);
  }
    
  findSelectedPermissions(profileid) 
  {
    return this._restClientService.load<PermissionSelectedDTO[]>('permission/find-selected-permissions?profileid='+profileid);
  }

  associer(associerPermissionAuProfile: AssocierPermissionAuProfile) {
    return this._restClientService.save<Permission>('permission/associer-permission-profile', associerPermissionAuProfile);
  }
  
  
  

}      

    